module.exports = __webpack_public_path__ + "img/1-4.c562bc4d.svg";